export default __webpack_public_path__ + "static/media/Group 1384.0a92e0bd.svg";